export const BILLING_REDUCER_NAME = 'billing'
export const BILLING_CHARGES_REDUCER_NAME = 'charges'
export const BILLING_CHARGES_LIST_REDUCER_NAME = 'listCharges'
